$(document).ready(function () {
    const productLayoutPath = '/productlayout';
    const pathAjax = '/action/product-layout';
    const pathSaveProductPositions = 'product-positions';
    const pathGetButton = 'buttons';
    const pathGetLeftSideTool = 'left-side-settings-tool';
    const pathGetHtmlChainedEvent = 'get-html-chained-event';
    const pathPublish = 'publish';
    const pathPublishAll = 'publish-all';
    const pathDeactivate = 'deactivate';
    const pathActivate = 'activate';
    const pathDuplicate = 'duplicate';
    const pathPopup = 'product-popup';
    const pathProductSearch = 'product-search';
    const pathCustomerSearch = 'customer-search';
    const pathProductLayoutProduct = 'product-layout-product';
    const pathDeleteProductLayoutImage = 'image';
    const pathDeleteProductLayoutProductImage = 'image';
    const pathExportCsvProductLayoutProducts = 'export-csv-product-layout-products';
    const pathMultipleEditProductLayoutProducts = 'multiple-edit-product-layout-products';

    const productButtonModalId = 'product_layout_popup';
    const productLayoutWrapperId = 'product_layout_wrapper';
    const leftSideSettingsToolWrapperId = 'left_side_settings_tool_wrapper';
    const popupChainedEventsWrapperId = 'product_layout_popup_chained_events_wrapper';
    const productLayoutWrapper = $('div#' + productLayoutWrapperId);

    let ajaxLockActive = false;

    let cropperObj = null;
    let productPickerSearchTimer = null;

    // Startup
    initGridDragable();
    initProductLayoutDaysTomSelect();
    if (window.ScaleToFitViewport && typeof window.ScaleToFitViewport.mount === 'function') {
        window.ScaleToFitViewport.mount($('#product_layout_activated_layouts_wrapper'));
    }

    // Go to create new product layout
    $(document).on('click', "button#product_layout_new", function () {
        window.location.href = productLayoutPath;
    });

    // Edit register license form, open form on the right side
    $(document).on('click', "div#product_layout_wrapper table#existing_product_layouts_table tbody td, div#product_layout_wrapper table#existing_deactivated_product_layouts_table tbody td", function () {
        let tr = $(this).closest('tr');
        let productLayoutId = tr.attr('product_layout_id');
        if (!productLayoutId) {
            return;
        }

        window.location.href = productLayoutPath + '/' + productLayoutId;
    });

    $(document).on('click', '#' + productLayoutWrapperId + ' #product_layout_display_deactivated', function () {
        const deactivatedLayoutsWrapper = $('#product_layout_deactivated_layouts_wrapper').removeClass('hidden');
        deactivatedLayoutsWrapper.removeClass('hidden');

        if (window.ScaleToFitViewport && typeof window.ScaleToFitViewport.mount === 'function') {
            window.ScaleToFitViewport.mount(deactivatedLayoutsWrapper);
        }

        return false;
    });

    // Display popup for button or choose for multiple editing
    $(document).on('click', "div#product_layout_wrapper ul#product_layout_sortable_ul li", function () {
        if ($('#product_layout_products_multiple_edit').is(':checked')) {
            if ($(this).hasClass('multiple-edit')) {
                $(this).removeClass('multiple-edit');
            } else {
                $(this).addClass('multiple-edit');
            }
        } else {
            if (ajaxLockActive === true) {
                return;
            }

            ajaxLockActive = true;

            let productLayoutProductId = $(this).attr('product_layout_product_id');
            displayProductPopup(productLayoutProductId);
        }
    });

    // Product search on enter
    $(document).on('keyup', 'div#' + productButtonModalId + ' input#product_layout_product_search', function (e) {
        if (e.keyCode !== 13 && $(this).val().length < 3) {
            return;
        }
        var searchString = $(this).val();
        productSearch(searchString)
        return false;
    });

    // Product search on click
    $(document).on('click', 'div#' + productButtonModalId + ' button#product_layout_product_search_button', function (e) {
        var searchString = $('div#' + productButtonModalId + ' input#product_layout_product_search').val();
        productSearch(searchString)
        return false;
    });

    // Select product from search result
    $(document).on('click', 'div#' + productButtonModalId + ' div#product_layout_product_search_result button.list-group-item', function () {
        let productId = $(this).attr('product_id');
        let productName = $(this).html();

        $('input[name="product_layout_product_search_selected_product"]').val(productId);
        $('div#' + productButtonModalId + ' #product_layout_popup_title').html(productName);
        $('div#' + productButtonModalId + ' #product_layout_popup_title').addClass('text-primary');
        $('div#product_layout_product_search_result').html('');
        $('div#' + productButtonModalId + ' input#product_layout_product_search').val('');
    });

    // Extra product search on enter
    $(document).on('keyup', 'div#' + productButtonModalId + ' input#extra_product_search', function (e) {
        if (e.keyCode !== 13 && $(this).val().length < 3) {
            return;
        }
        var searchString = $(this).val();
        extraProductSearch(searchString)
        return false;
    });

    // Extra product search on click
    $(document).on('click', 'div#' + productButtonModalId + ' button#extra_product_search_button', function (e) {
        var searchString = $('div#' + productButtonModalId + ' input#extra_product_search').val();
        extraProductSearch(searchString)
        return false;
    });

    // Select extra product from search result
    $(document).on('click', 'div#' + productButtonModalId + ' div#extra_product_search_result button.list-group-item', function () {
        let productId = $(this).attr('product_id');
        let productName = $(this).html();

        $('input[name="extra_product_search_selected_product"]').val(productId);
        $('div#' + productButtonModalId + ' #product_layout_popup_title').html(productName);
        $('div#' + productButtonModalId + ' #product_layout_popup_title').addClass('text-primary');
        $('div#extra_product_search_result').html('');
        $('div#' + productButtonModalId + ' input#extra_product_search').val('');
    });

    // Customer search on enter
    $(document).on('keyup', 'div#' + productButtonModalId + ' input#customer_search', function (e) {
        if (e.keyCode !== 13 && $(this).val().length < 3) {
            return;
        }
        var searchString = $(this).val();
        customerSearch(searchString)
        return false;
    });

    // Customer search on click
    $(document).on('click', 'div#' + productButtonModalId + ' button#customer_search_button', function (e) {
        var searchString = $('div#' + productButtonModalId + ' input#customer_search').val();
        customerSearch(searchString)
        return false;
    });

    // Select customer from search result
    $(document).on('click', 'div#' + productButtonModalId + ' div#customer_search_result button.list-group-item', function () {
        let customerId = $(this).attr('customer_id');
        let customerName = $(this).html();

        $('input[name="customer_search_selected_customer"]').val(customerId);
        $('div#' + productButtonModalId + ' #product_layout_popup_title').html(customerName);
        $('div#' + productButtonModalId + ' #product_layout_popup_title').addClass('text-primary');
        $('div#customer_search_result').html('');
        $('div#' + productButtonModalId + ' input#customer_search').val('');
    });

    // Display correct inputs when changing target type
    $(document).on('change', 'div#' + productButtonModalId + ' select[name="product_layout_button_target_type"]', function () {
        refreshModalAfterTargetTypeSelection($('div#' + productButtonModalId + ' select[name="product_layout_button_target_type"]').val());
    });

    $(document).on('change', 'div#' + productButtonModalId + ' select[name="ticket_product_config_id"]', function () {
        const selectedConfigName = $(this).find('option:selected').text().trim();

        if ($(this).val()) {
            $('div#' + productButtonModalId + ' #product_layout_popup_title')
                .text(selectedConfigName)
                .addClass('text-primary');
        }
    });


    /**
     *Change page number
     */
    $(document).on('click', "div#next_prev_page_wrapper button", function () {
        if (ajaxLockActive === true) {
            return;
        }

        var currentPageNumber = $('div#next_prev_page_wrapper span#product_layout_page_number').html() * 1;
        if (isNaN(currentPageNumber)) {
            alert('Ugyldig sidetall');
            return
        }

        if ($(this).attr('id') == 'product_layout_prev_page_v2') {
            currentPageNumber -= 1;
        } else {
            currentPageNumber += 1;
        }

        if (currentPageNumber <= 0) {
            return;
        }

        $('div#next_prev_page_wrapper span#product_layout_page_number').html(currentPageNumber)
        getProductButtons(currentPageNumber);
    });


    $(document).on('click', 'div#' + productButtonModalId + ' .product_layout_cropper_change_aspect_ratio_btn', function (e) {
        e.stopPropagation();

        const selfBtn = $(this);
        const aspectRatio = selfBtn.data('aspect-ratio');
        const siblingButtons = selfBtn.closest('.product_layout_cropper_aspect_ratio_buttons').find('.product_layout_cropper_change_aspect_ratio_btn').not(selfBtn);

        if (cropperObj instanceof Cropper) {
            cropperObj.setAspectRatio(aspectRatio);
            selfBtn.addClass('is-active');
            siblingButtons.removeClass('is-active');
        }

        return false;
    });

    /**
     * Destroy the cropper and remove the instance from the image
     */
    function destroyCropper() {
        if (cropperObj instanceof Cropper) {
            cropperObj.destroy();
        }
        cropperObj = null;
    }

    /**
     * Upload image to the input and display cropper
     */
    $(document).on('change', 'div#' + productButtonModalId + ' #prodct_layout_product_image', function (e) {
        const file = e.target.files[0];
        const previewInfo = $(document).find('div#' + productButtonModalId + ' #product_layout_cropper_preview_info');
        const aspectRatio = $(document).find('div#' + productButtonModalId + ' .product_layout_cropper_change_aspect_ratio_btn.is-active').data('aspect-ratio');
        if (file) {
            showPreloader();
            const reader = new FileReader();
            reader.onload = (event) => {
                const image = $(document).find('div#' + productButtonModalId + ' img#cropper-img');
                image.on('load', function (e) {
                    destroyCropper();
                    cropperObj = new Cropper(this, {
                        aspectRatio: aspectRatio ? aspectRatio : 'auto',
                        minContainerHeight: 400,
                        minContainerWidth: 600,
                        ready() {
                            $(document).find('div#' + productButtonModalId + ' #product_layout_cropper').css({
                                'display': 'block'
                            });
                            hidePreloader();
                        },
                        crop(event) {
                            previewInfo.text(`Width: ${Math.floor(event.detail.width)}px, Height: ${Math.floor(event.detail.height)}px`);
                        }
                    });
                    setTimeout(() => {
                        hidePreloader();
                    }, 1000);
                });
                image.attr('src', event.target.result);
            };
            reader.readAsDataURL(file);
        }
    });

    /**
     * Cancel cropper
     */
    $(document).on('click', 'div#' + productButtonModalId + ' #product_layout_cropper_cancel', function (e) {
        destroyCropper();
        // hide cropper modal
        $(document).find('div#' + productButtonModalId + ' #product_layout_cropper').css({'display': 'none'});

        // clear uploaded image
        $(document).find('div#' + productButtonModalId + ' #prodct_layout_product_image').val('');

        // clear cropper data
        const image = $(document).find('div#' + productButtonModalId + ' img#cropper-img');
        image.attr('src', '');
        image.off('load');

        // clear and hide preview image in the modal
        $(document).find('div#' + productButtonModalId + ' #product_layout_cropper_preview_img').attr('src', '');
        $(document).find('div#' + productButtonModalId + ' #product_layout_cropper_preview').css({'display': 'none'});

        return false;
    });

    /**
     * Confirm cropping result
     */
    $(document).on('click', 'div#' + productButtonModalId + ' #product_layout_cropper_confirm', function (e) {
        // set cropped image to preview
        const src = cropperObj.getCroppedCanvas().toDataURL('image/png');
        $(document).find('div#' + productButtonModalId + ' #product_layout_cropper_preview_img').attr('src', src);

        // clear cropper data
        const image = $(document).find('div#' + productButtonModalId + ' img#cropper-img');
        image.attr('src', '');
        image.off('load');

        $(document).find('div#' + productButtonModalId + ' #product_layout_cropper').css({'display': 'none'});
        $(document).find('div#' + productButtonModalId + ' #product_layout_cropper_preview').css({'display': 'block'});

        return false;
    });


    /**
     * Delete cropped preview image and clear uploaded image
     */
    $(document).on('click', 'div#' + productButtonModalId + ' #product_layout_cropper_preview_delete', function (e) {
        destroyCropper();

        // clear preview data
        $(document).find('div#' + productButtonModalId + ' #product_layout_cropper_preview').css({'display': 'none'});
        $(document).find('div#' + productButtonModalId + ' #product_layout_cropper_preview_img').attr('src', '');

        // clear uploaded image
        $(document).find('div#' + productButtonModalId + ' #prodct_layout_product_image').val('');

        // clear cropper data
        const image = $(document).find('div#' + productButtonModalId + ' img#cropper-img');
        image.attr('src', '');
        image.off('load');

        return false;
    });

    /**
     * Get Blob from cropper object
     *
     * @param cropperObj
     * @returns {Promise<unknown>}
     */
    function getCroppedImageBlob(cropperObj) {
        return new Promise((resolve, reject) => {
            if (!(cropperObj instanceof Cropper)) {
                resolve(null);
                return;
            }
            cropperObj.getCroppedCanvas().toBlob((blob) => {
                if (blob) {
                    resolve(blob);
                } else {
                    resolve(null);
                }
            }, 'image/png', 1);
        });
    }

    function getSelectedProductImageFile() {
        const input = $(document).find('div#' + productButtonModalId + ' input#prodct_layout_product_image')[0];

        if (!input || !input.files || !input.files.length) {
            return null;
        }

        return input.files[0];
    }

    // Save button
    $(document).on('click', 'div#' + productButtonModalId + ' button#product_layout_save_product_button', function () {
        let button = $(this);
        let buttonOriginalText = button.html();
        button.html('<img src="/includes/article/images/loading.gif?v=1.000" style="width:25px; height: 25px;"/>');
        let productLayoutProductId = $('div#' + productButtonModalId + ' input[name="product_layout_product_id"]').val();
        let bgColor = $('div#' + productButtonModalId + ' button#product_layout_background_color_picker').css("backgroundColor");
        let fontColor = $('div#' + productButtonModalId + ' button#product_layout_font_color_picker').css("backgroundColor");
        let fontSize = $('div#' + productButtonModalId + ' select#product_layout_font_size_picker').val();
        let targetType = $('div#' + productButtonModalId + ' select[name="product_layout_button_target_type"]').val() * 1;
        let productId = $('div#' + productButtonModalId + ' input[name="product_layout_product_search_selected_product"]').val();
        let extraProductId = $('div#' + productButtonModalId + ' input[name="extra_product_search_selected_product"]').val();
        let customerId = $('div#' + productButtonModalId + ' input[name="customer_search_selected_customer"]').val();
        let productLayoutId = $('div#' + productButtonModalId + ' select[name="target_product_layout_id"]').val();
        let productGroupId = $('div#' + productButtonModalId + ' select[name="target_product_group_id"]').val();
        let ticketProductConfigId = $('div#' + productButtonModalId + ' select[name="ticket_product_config_id"]').val();
        let buttonText = $('div#' + productButtonModalId + ' input[name="product_layout_product_button_text"]').val();

        let formData = new FormData();
        formData.append('target_type', targetType);
        if (targetType === 0) {
            formData.append('product_id', productId);
        } else if (targetType === 1) {
            formData.append('product_layout_id', productLayoutId);
        } else if (targetType === 2) {
            formData.append('product_group_id', productGroupId);
        } else if (targetType === 4) {
            formData.append('extra_product_id', extraProductId);
        } else if (targetType === 6) {
            formData.append('customer_id', customerId);
        } else if (targetType === 7) {
            formData.append('ticket_product_config_id', ticketProductConfigId);
        }

        formData.append('font_size', fontSize);
        formData.append('bg_color', bgColor);
        formData.append('font_color', fontColor);
        formData.append('button_text', buttonText);

        // Basic validation: product target requires a valid product_id
        if (targetType === 0 && (!productId || isNaN(productId) || parseInt(productId, 10) <= 0)) {
            button.html(buttonOriginalText);
            alert('Ugyldig produkt. Velg et produkt for knappen.');
            ajaxLockActive = false;
            return false;
        }

        const ticketProductConfigIdValue = String(ticketProductConfigId || '').trim();
        if (targetType === 7 && !/^[1-9]\d*$/.test(ticketProductConfigIdValue)) {
            button.html(buttonOriginalText);
            alert('Velg en gyldig billettproduktkonfigurasjon for knappen.');
            ajaxLockActive = false;
            return false;
        }

        // Chained events are only available for products
        if (targetType === 0) {
            $('div#' + productButtonModalId + ' select[name^="product_layout_chained_event_type"]').each(function () {
                formData.append("product_layout_chained_event_type_arr[]", $(this).val());
            });
            $('div#' + productButtonModalId + ' select[name^="product_layout_chained_event_layout_id"]').each(function () {
                formData.append("product_layout_chained_event_layout_id_arr[]", $(this).val());
            });
        }

        // Add image if present in the form
        // if ($('input#prodct_layout_product_image').length) {
        //     console.log($('div#' + productLayoutWrapperId + ' input#prodct_layout_product_image')[0].files[0])
        //     formData.append('image', $('div#' + productLayoutWrapperId + ' input#prodct_layout_product_image')[0].files[0]);
        // }

        getCroppedImageBlob(cropperObj).then((blob) => {
            const originFile = getSelectedProductImageFile();
            if (blob instanceof Blob && originFile instanceof File) {
                formData.append('image', blob, originFile.name);
                destroyCropper();
            }
        }).finally(() => {
            $.ajax({
                type: 'POST',
                url: pathAjax + '/' + getProductLayoutId() + '/' + pathProductLayoutProduct + '/' + productLayoutProductId,
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json',
            }).success(function (data) {
                // If this was a newly created button, persist any pending TEXT2 translations now that we have an ID
                try {
                    var createdId = 0;
                    if (data && (data.product_layout_product_id || data.id)) {
                        createdId = parseInt(data.product_layout_product_id || data.id, 10) || 0;
                    }
                    var effectiveId = createdId > 0 ? createdId : (parseInt(productLayoutProductId, 10) || 0);
                    if (effectiveId > 0 && targetType === 0 && productId && parseInt(productId, 10) > 0) {
                        var enVal = ($('div#' + productButtonModalId + ' #product_layout_product_button_text_en').val() || '').trim();
                        var deVal = ($('div#' + productButtonModalId + ' #product_layout_product_button_text_de').val() || '').trim();
                        var reqs = [];
                        function saveText2(lang, value) {
                            return $.ajax({
                                type: 'POST',
                                url: '/action/translations/update-product-layout-product-translations',
                                data: {
                                    productLayoutProductId: effectiveId,
                                    field: 'name',
                                    lang: lang,
                                    value: value
                                },
                                dataType: 'json'
                            });
                        }
                        if (enVal) { reqs.push(saveText2('en', enVal)); }
                        if (deVal) { reqs.push(saveText2('de', deVal)); }
                        if (reqs.length) {
                            $.when.apply($, reqs).always(function () {
                                // no-op; proceed to refresh UI
                                closePopup();
                                getProductButtons(getPageNumber());
                            });
                            return; // prevent double close/refresh below
                        }
                    }
                } catch (e) {}
                closePopup();
                getProductButtons(getPageNumber());
            }).error(function (data) {
                button.html(buttonOriginalText);
                let errors = $.parseJSON(data.responseText).errors;
                alert(errors);
            }).always(function () {
                ajaxLockActive = false;
            });
        });

        return false;
    });

    // Publish product layout
    $(document).on('click', 'div#' + productLayoutWrapperId + ' button#product_layout_publish_layout_v2', function () {
        if (!confirm('Vil du publisere hovedgruppe til kassene?')) {
            return;
        }

        $.ajax({
            type: 'POST',
            url: pathAjax + '/' + getProductLayoutId() + '/' + pathPublish,
            data: {},
            dataType: 'json',
        }).success(function (data) {
            alert('Hovedgruppe publisert');
        }).error(function (data) {
            alert('Kunne ikke publisere, vennligst prøv igjen');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    $(document).on('click', 'div#' + productLayoutWrapperId + ' #publish_all_product_layouts', function (e) {
        console.log('click publish all product layouts')
        e.preventDefault();
        if (!confirm('Vil du publisere alle hovedgrupper til kassene?')) return;

        $.ajax({
            type: 'POST',
            url: pathAjax + '/' + pathPublishAll,
            dataType: 'json'
        }).done(function () {
            alert('Alle hovedgrupper publisert');
        }).fail(function () {
            alert('Kunne ikke publisere, vennligst prov igjen');
        }).always(function () {
            ajaxLockActive = false;
        });
    });

    // Deactivate product layout
    $(document).on('click', 'div#' + productLayoutWrapperId + ' button#product_layout_deactivate_layout_v2', function () {
        if (!confirm('Vil du deaktivere denne hovedgruppen?')) {
            return;
        }

        const productLayoutId = getProductLayoutId();
        
        $.ajax({
            type: 'POST',
            url: pathAjax + '/' + productLayoutId + '/' + pathDeactivate,
            data: {},
            dataType: 'json',
        }).success(function (data) {
            // Soft delete translations when deactivating
            if (productLayoutId > 0) {
                deleteProductLayoutTranslations(productLayoutId);
            }
            alert('Hovedgruppe deaktivert');
        }).error(function (data) {
            alert('Kunne ikke deaktivere, vennligst prøv igjen');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    // Reactivate product layout
    $(document).on('click', 'div#' + productLayoutWrapperId + ' button#product_layout_reactivate_layout_v2', function () {
        if (!confirm('Vil du aktivere denne hovedgruppen?')) {
            return;
        }

        const productLayoutId = getProductLayoutId();
        
        $.ajax({
            type: 'POST',
            url: pathAjax + '/' + productLayoutId + '/' + pathActivate,
            data: {},
            dataType: 'json',
        }).success(function (data) {
            // Restore translations when reactivating
            if (productLayoutId > 0) {
                restoreProductLayoutTranslations(productLayoutId);
            }
            alert('Hovedgruppe aktivert');
        }).error(function (data) {
            alert('Kunne ikke aktivere, vennligst prøv igjen');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    // Duplicate product layout
    $(document).on('click', 'div#' + productLayoutWrapperId + ' button#product_layout_duplicate_layout_v2', function () {
        if (!confirm('Vil du duplisere denne hovedgruppen?')) {
            return;
        }

        $.ajax({
            type: 'POST',
            url: pathAjax + '/' + getProductLayoutId() + '/' + pathDuplicate,
            data: {},
            dataType: 'json',
        }).success(function (data) {
            if (data.product_layout_id) {
                const lastDuplicateId = data.last_duplicate_id > 0 ? data.last_duplicate_id : getProductLayoutId();
                $("#product_layout_list_group .list-group-item[href='/productlayout/" + lastDuplicateId + "']").after(data.duplicate_link);
            }
        }).error(function (data) {
            alert('Kunne ikke duplisere, vennligst prøv igjen');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    // delete product layout image
    $(document).on('click', 'div#' + productLayoutWrapperId + ' div#delete_product_layout_image', function () {
        if (!confirm('Er du sikker på at du vil slette bildet?')) {
            return;
        }

        $.ajax({
            type: 'DELETE',
            url: pathAjax + '/' + getProductLayoutId() + '/' + pathDeleteProductLayoutImage,
            data: {},
            dataType: 'json',
        }).success(function (data) {
            updateLeftSideSettingsTool();
        }).error(function (data) {
            alert('Kunne ikke lagre, vennligst prøv igjen');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    // delete product layout image
    $(document).on('click', 'div#' + productButtonModalId + ' #delete_product_layout_product_image', function () {
        if (!confirm('Er du sikker på at du vil slette bildet?')) {
            return;
        }

        let productLayoutProductId = $('div#' + productButtonModalId + ' input[name="product_layout_product_id"]').val();

        $.ajax({
            type: 'DELETE',
            url: pathAjax + '/' + getProductLayoutId() + '/product-layout-product/' + productLayoutProductId + '/' + pathDeleteProductLayoutProductImage,
            data: {},
            dataType: 'json',
        }).success(function (data) {
            displayProductPopup(productLayoutProductId)
        }).error(function (data) {
            alert('Kunne ikke lagre, vennligst prøv igjen');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    // Add chained event
    $(document).on('click', 'div#' + productButtonModalId + ' button#product_layout_add_popup_chained_event', function () {

        $.ajax({
            type: 'GET',
            url: pathAjax + '/' + pathGetHtmlChainedEvent,
            data: {},
            dataType: 'json',
        }).success(function (data) {
            $('div#' + productButtonModalId + ' div#' + popupChainedEventsWrapperId).append(data.html);
        }).error(function (data) {
            alert('Kunne ikke legge til hovedgruppe, vennligst last siden på nytt');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    // Remove chained event
    $(document).on('click', 'div#' + productButtonModalId + ' div.chained_event_row .product_layout_remove_chained_event', function () {
        let chainedEventRow = $(this).closest('div.chained_event_row');
        chainedEventRow.remove();
        return false;
    });


    $(document).on('click', 'div#' + productButtonModalId + ' button#product_layout_deactivate_product_button', function () {
        let productName = $('div#' + productButtonModalId + ' #product_layout_popup_title').html();
        if (!confirm("Vil du deaktivere\n" + productName + "?")) {
            return;
        }

        let productLayoutProductId = parseInt($('div#' + productButtonModalId + ' input[name="product_layout_product_id"]').val(), 10) || 0;
        $.ajax({
            type: 'POST',
            url: pathAjax + '/' + getProductLayoutId() + '/' + pathProductLayoutProduct + '/' + productLayoutProductId,
            data: {
                image: '',
                target_type: 0,
                product_id: 0,
                font_size: 0,
                bg_color: '',
                font_color: ''
            },
            dataType: 'json'
        }).success(function (data) {
            if (productLayoutProductId > 0) {
                deleteProductLayoutProductTranslations(productLayoutProductId);
            }
            closePopup();
            getProductButtons(getPageNumber());
        }).error(function (data) {
            alert('Kunne ikke lagre, vennligst prøv igjen');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    // Save new product layout
    $(document).on('click', 'div#' + productLayoutWrapperId + ' div#save_new_product_layout', function () {
        if (ajaxLockActive === true) {
            return;
        }
        ajaxLockActive = true;

        let name = $.trim($('div#' + productLayoutWrapperId + ' div#new_product_layout_wrapper input[name="name"]').val());
        if (name === '') {
            displayTailwindAlert('Feil', 'Navn kan ikke være tomt', $(this).closest('#new_product_layout_form_wrapper'), 'error');
            ajaxLockActive = false;
            return;
        }

        $.ajax({
            type: 'POST',
            url: pathAjax,
            data: {
                name: name
            },
            dataType: 'json'
        }).success(function (data) {
            window.location.href = productLayoutPath + '/' + data.product_layout_id;
        }).error(function (data) {
            alert('Kunne ikke lagre, vennligst last siden på nytt og prøv igjen');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    // Update on change
    $(document).on('change', 'div#' + productLayoutWrapperId + ' select#product_layout_format_v2, div#' + productLayoutWrapperId + ' input#product_layout_name_edit_v2, div#' + productLayoutWrapperId + ' select#time_of_day_from_v2, div#' + productLayoutWrapperId + ' select#time_of_day_to_v2, div#' + productLayoutWrapperId + ' select#product_layout_available_days_v2, div#' + productLayoutWrapperId + ' input#product_layout_image', function () {
        let updateProductButtons = false;
        let updateLeftSide = false;
        if ($(this).attr('id') === 'product_layout_format_v2') {
            updateProductButtons = true;
        }
        if ($(this).attr('id') === 'product_layout_image') {
            updateLeftSide = true;
        }
        updateProductLayout(updateProductButtons, updateLeftSide);
    });

    // export csv file with product layout products by productLayoutId
    $(document).on('click', '#export_csv_product_layout_products', function () {
        $.ajax({
            type: 'GET',
            url: pathAjax + '/' + getProductLayoutId() + '/' + pathExportCsvProductLayoutProducts
        }).success(function (data) {
            const blob = new Blob([data], {type: 'text/csv'});
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.setAttribute('href', url)
            a.setAttribute('download', 'product.layout.products.csv');
            a.click();
            a.remove();
        }).error(function (data) {
            const errors = $.parseJSON(data.responseText).errors;
            alert(errors);
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    function productSearch(searchString) {
        if (ajaxLockActive === true) {
            return;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'GET',
            url: pathAjax + '/' + pathProductSearch,
            data: {
                search_string: searchString
            },
            dataType: 'json'
        }).success(function (data) {
            $('div#product_layout_product_search_result').html(data.search_result);
        }).error(function (data) {
            alert('Kunne ikke hente skjema');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    }

    function extraProductSearch(searchString) {
        if (ajaxLockActive === true) {
            return;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'GET',
            url: pathAjax + '/' + pathProductSearch,
            data: {
                search_string: searchString
            },
            dataType: 'json'
        }).success(function (data) {
            $('div#extra_product_search_result').html(data.search_result);
        }).error(function (data) {
            alert('Kunne ikke hente skjema');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    }

    function customerSearch(searchString) {
        if (ajaxLockActive === true) {
            return;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'GET',
            url: pathAjax + '/' + pathCustomerSearch,
            data: {
                search_string: searchString
            },
            dataType: 'json'
        }).success(function (data) {
            $('div#customer_search_result').html(data.search_result);
        }).error(function (data) {
            alert('Kunne ikke hente skjema');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    }


    // Update product layout
    function updateProductLayout(updateProductButtons, updateLeftSide) {
        if (ajaxLockActive === true) {
            return;
        }
        ajaxLockActive = true;

        let format = $('div#' + productLayoutWrapperId + ' select#product_layout_format_v2').val();
        let formatArray = format.split('x');

        let horizontalProductCount = formatArray[0];
        let verticalProductCount = formatArray[1];
        let name = $.trim($('div#' + productLayoutWrapperId + ' input#product_layout_name_edit_v2').val());
        let timeOfDayFrom = $.trim($('div#' + productLayoutWrapperId + ' select#time_of_day_from_v2').val());
        let timeOfDayTo = $.trim($('div#' + productLayoutWrapperId + ' select#time_of_day_to_v2').val());
        let availableDays = getProductLayoutAvailableDays();

        let formData = new FormData();
        formData.append('horizontal_product_count', verticalProductCount);
        formData.append('vertical_product_count', horizontalProductCount);
        formData.append('name', name);
        formData.append('time_of_day_from', timeOfDayFrom);
        formData.append('time_of_day_to', timeOfDayTo);
        formData.append('available_days', availableDays);
        if ($('div#' + leftSideSettingsToolWrapperId + ' input#product_layout_image').length) {
            formData.append('image', $('div#' + productLayoutWrapperId + ' input#product_layout_image')[0].files[0]);
        }

        $.ajax({
            type: 'POST',
            url: pathAjax + '/' + getProductLayoutId(),
            data: formData,
            processData: false,
            contentType: false,
            dataType: 'json'
        }).success(function (data) {
            ajaxLockActive = false;

            if (updateProductButtons) {
                getProductButtons(getPageNumber());
            }

            if (updateLeftSide) {
                updateLeftSideSettingsTool();
            }
        }).error(function (data) {
            alert('Kunne ikke lagre, vennligst prøv igjen');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    }

    // Update product layout
    function updateLeftSideSettingsTool() {
        if (ajaxLockActive === true) {
            return;
        }
        ajaxLockActive = true;

        $.ajax({
            type: 'GET',
            url: pathAjax + '/' + getProductLayoutId() + '/' + pathGetLeftSideTool,
            data: {},
            dataType: 'json'
        }).success(function (data) {
            $('div#' + leftSideSettingsToolWrapperId).html(data.html);
            initProductLayoutDaysTomSelect();
        }).error(function (data) {
            alert('Kunne ikke oppdatere venstre verktøy-side, vennligst last siden på nytt');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    }

    function initProductLayoutDaysTomSelect() {
        const selectElement = document.getElementById('product_layout_available_days_v2');
        if (!selectElement || selectElement.tomselect) {
            return;
        }

        const placeholder = selectElement.dataset.placeholder || '';
        if (typeof initializeTomMultiSelect === 'function') {
            initializeTomMultiSelect(selectElement.id, placeholder);
            return;
        }

        if (typeof TomSelect !== 'function') {
            return;
        }

        new TomSelect(selectElement, {
            plugins: ['remove_button'],
            searchField: ['text'],
            placeholder: placeholder,
            persist: false,
            create: false
        });
    }

    function getProductLayoutAvailableDays() {
        const selectElement = document.getElementById('product_layout_available_days_v2');
        if (!selectElement) {
            return 0;
        }

        const selectedValues = selectElement.tomselect
            ? selectElement.tomselect.getValue()
            : $('div#' + productLayoutWrapperId + ' select#product_layout_available_days_v2').val();
        const values = Array.isArray(selectedValues)
            ? selectedValues
            : (selectedValues ? [selectedValues] : []);

        if (values.length === 0) {
            return 0;
        }

        return values.reduce(function (sum, value) {
            const numericValue = parseInt(value, 10);
            return Number.isNaN(numericValue) ? sum : sum + numericValue;
        }, 0);
    }

    function getTailwindModal(modalId) {
        const modalElement = document.getElementById(modalId);

        if (!modalElement || !window.tailwind || !window.tailwind.Modal || typeof window.tailwind.Modal.getOrCreateInstance !== 'function') {
            return null;
        }

        return window.tailwind.Modal.getOrCreateInstance(modalElement);
    }

    function showModal(modalId) {
        const tailwindModal = getTailwindModal(modalId);

        if (tailwindModal) {
            tailwindModal.show();
            return;
        }

        $('div#' + modalId).addClass('show').attr('aria-hidden', 'false').show();
    }

    function hideModal(modalId) {
        const tailwindModal = getTailwindModal(modalId);

        if (tailwindModal) {
            tailwindModal.hide();
            return;
        }

        const modal = $('#' + modalId);
        modal.removeClass('show').attr('aria-hidden', 'true').hide();
        modal.trigger('hidden.tw.modal');
    }

    function closePopup() {
        // hide existing product button modal
        if ($('div#' + productButtonModalId).length) {
            hideModal(productButtonModalId);
        }
    }

    // remove existing product button modal
    $(document).on('hidden.tw.modal', 'div#' + productButtonModalId, function (e) {
        $(this).remove();
    });

    function displayProductPopup(productLayoutProductId) {
        $.ajax({
            type: 'GET',
            url: pathAjax + '/' + getProductLayoutId() + '/' + pathPopup + '/' + productLayoutProductId,
            data: {},
            dataType: 'json'
        }).success(function (data) {
            displayProductPopupFromHtml(data.modal_content);
            refreshModalAfterTargetTypeSelection($('div#' + productButtonModalId + ' select[name="product_layout_button_target_type"]').val());
        }).error(function (data) {
            alert('Kunne ikke hente informasjon om knapp');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    }

    function displayProductPopupFromHtml(popupHtml) {
        closePopup();
        $(document).find('div#' + productButtonModalId).remove();

        try {
            const $translationsModal = $('#productLayoutTranslations');
            if ($translationsModal.length) {
                hideModal('productLayoutTranslations');
            }
        } catch (e) {}
        
        productLayoutWrapper.append(popupHtml);
        showModal(productButtonModalId);

        initColorPickers(productButtonModalId);
    }

    /**
     * Iterates all the products and finds which product belongs in which position
     */
    function saveProductPositions() {
        if (ajaxLockActive === true) {
            return;
        }

        ajaxLockActive = true;

        var productsPerPage = $("input#product_layout_page_product_count").val() * 1;
        var pageNumber = getPageNumber();
        var productLayoutProductIds = [];

        //Calculate start position, could on second or third page, position must be calculated
        $("ul#product_layout_sortable_ul li").each(function () {
            productLayoutProductIds.push($(this).attr("product_layout_product_id"));
        });

        var startPosition = productsPerPage * (pageNumber - 1) + 1; //Calculate the first position on this page (EG: 25 * 1 + 1= 26, the first product on page 2 if 5x5 format)
        //Save new position
        $.ajax({
            type: 'POST',
            url: pathAjax + '/' + getProductLayoutId() + '/' + pathSaveProductPositions,
            data: {
                start_position: startPosition,
                product_layout_product_ids: JSON.stringify(productLayoutProductIds)
            },
            dataType: 'json'
        }).success(function (data) {
            // licenseListWrapper.html(data.html);
        }).error(function (data) {
            alert('Kunne ikke hente skjema');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    }

    /**
     * Ensure inline EN/DE inputs exist next to button text and sync with hidden fields
     */
    function ensureInlineText2TranslationInputs() {
        const popup = $('div#' + productButtonModalId);
        if (!popup.length) {
            return;
        }

        const afterGroup = popup.find('#product_layout_product_button_text').closest('#product_layout_product_button_text_row');
        if (!afterGroup.length) {
            return;
        }

        if (!popup.find('#product_layout_product_button_text_translations').length) {
            const productLayoutProductId = parseInt(popup.find('input[name="product_layout_product_id"]').val(), 10) || 0;
            const inputClasses = 'w-full rounded-md border border-slate-200 px-3 py-2 text-sm shadow-sm placeholder:text-slate-400/90 focus:border-primary focus:border-opacity-40 focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none';
            const translationsHtml = '' +
                '<div class="hidden flex flex-col gap-2 sm:flex-row sm:items-center" id="product_layout_product_button_text_translations">' +
                '  <label class="text-sm font-medium text-slate-700 sm:w-32 sm:text-right" for="product_layout_product_button_text_en">Engelsk</label>' +
                '  <div class="flex-1">' +
                '    <input type="text" class="' + inputClasses + '" id="product_layout_product_button_text_en" placeholder="English translation" value="">' +
                '  </div>' +
                '</div>' +
                '<div class="hidden flex flex-col gap-2 sm:flex-row sm:items-center" id="product_layout_product_button_text_translations_de">' +
                '  <label class="text-sm font-medium text-slate-700 sm:w-32 sm:text-right" for="product_layout_product_button_text_de">Tysk</label>' +
                '  <div class="flex-1">' +
                '    <input type="text" class="' + inputClasses + '" id="product_layout_product_button_text_de" placeholder="German translation" value="">' +
                '  </div>' +
                '</div>';
            afterGroup.after(translationsHtml);

            // If we have a saved button, fetch saved translations from API and prefill
            if (productLayoutProductId > 0) {
                $.ajax({
                    type: 'GET',
                    url: '/action/translations/product-layout-product-translations',
                    data: {
                        productLayoutProductId: productLayoutProductId,
                        languages: 'en-GB,de-DE'
                    },
                    dataType: 'json'
                }).done(function (res) {
                    try {
                        const tr = (res && res.translations) ? res.translations : {};
                        const en = tr['en-GB'] && tr['en-GB'].name ? tr['en-GB'].name : (tr['en'] && tr['en'].name ? tr['en'].name : '');
                        const de = tr['de-DE'] && tr['de-DE'].name ? tr['de-DE'].name : (tr['de'] && tr['de'].name ? tr['de'].name : '');
                        if (typeof en === 'string') {
                            popup.find('#product_layout_product_button_text_en').val(en);
                        }
                        if (typeof de === 'string') {
                            popup.find('#product_layout_product_button_text_de').val(de);
                        }
                    } catch (e) { /* ignore */ }
                });
            }
        }
    }

    // Open inline text2 translation inputs for product layout button
    $(document).on('click', 'div#' + productButtonModalId + ' #openText2Translations', function (e) {
        e.preventDefault();
        const popup = $('div#' + productButtonModalId);
        ensureInlineText2TranslationInputs();
        const blocks = popup.find('#product_layout_product_button_text_translations, #product_layout_product_button_text_translations_de');
        if (blocks.length) {
            const shouldShow = blocks.first().hasClass('hidden');
            blocks.toggleClass('hidden', !shouldShow);
            if (shouldShow) {
                popup.find('#product_layout_product_button_text_en').focus();
            }
        }
        return false;
    });

    $(document).on('show.tw.modal', '#productLayoutTranslations', function () {
        $('#productLayoutTranslations #name_nb').focus().select();
    });

    function getProductButtons(pageNumber) {
        if (ajaxLockActive === true) {
            return;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'GET',
            url: pathAjax + '/' + getProductLayoutId() + '/' + pathGetButton,
            data: {
                page_number: pageNumber
            },
            dataType: 'json'
        }).success(function (data) {
            $('div#product_layout_products').html(data.modal_content);
            initGridDragable();
        }).error(function (data) {
            alert('Kunne ikke hente skjema');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    }

    function getProductLayoutId() {
        return $('div#product_layout_wrapper input#product_layout_id').val() * 1;
    }

    function getPageNumber() {
        return $("span#product_layout_page_number").html() * 1;
    }

    function initColorPickers(modalId) {
        $('div#' + modalId + ' button.product_layout_color_picker').each(function () {
            $(this).simpleColorPicker({
                showEffect: 'fade',
                hideEffect: 'slide',
                onChangeColor: function (color) {
                    $(this).css("background", color);
                }
            });
        });
    }


    /**
     *Initialize product list as a dragable grid
     */
    function initGridDragable() {
        if ($("ul#product_layout_sortable_ul").length) {
            const sortable = new Sortable(document.getElementById('product_layout_sortable_ul'), {
                sort: true,
                swap: true,
                swapClass: "highlight",
                onUpdate: function (e) {
                    const mode = $('#left_side_settings_tool_wrapper input[name="dragAndDropMode"]:checked').val();

                    if(mode === 'replace') {
                        const oldProductItem = $(e.swapItem);
                        const oldProductId = $(e.swapItem).attr('product_layout_product_id');

                        oldProductItem.css({background: 'none', fontSize: 0})
                        oldProductItem.find('.product_layout_product_name').html('');

                        $.ajax({
                            type: 'POST',
                            url: pathAjax + '/' + getProductLayoutId() + '/' + pathProductLayoutProduct + '/' + oldProductId,
                            data: {
                                target_type: 0,
                                product_id: 0,
                                font_size: 0,
                                bg_color: '',
                                font_color: ''
                            },
                            dataType: 'json'
                        }).success(function (data) {
                            saveProductPositions();
                        }).error(function (data) {
                            alert('Kunne ikke lagre, vennligst prøv igjen');
                        }).always(function () {
                            ajaxLockActive = false;
                        });
                    } else {
                        saveProductPositions();
                    }
                }
            });

            // switch drag and drop mode
            $('#left_side_settings_tool_wrapper input[name="dragAndDropMode"]').on('click', function(e) {
                if(e.target.value === 'move') {
                    sortable.option('swap', false);
                }

                if(e.target.value === 'swap' || e.target.value === 'replace') {
                    sortable.option('swap', true);
                }
            });
        }
    }

    function displayTicketProductConfigMessage(message) {
        const messageElement = $('div#' + productButtonModalId + ' #ticket_product_config_message');
        if (!messageElement.length) {
            return;
        }

        messageElement.text(message || '');
        messageElement.toggleClass('hidden', !message);
    }

    function loadTicketProductConfigs() {
        const popup = $('div#' + productButtonModalId);
        const select = popup.find('select[name="ticket_product_config_id"]');
        if (!select.length
            || select.attr('data-configs-loaded') === '1'
            || select.attr('data-configs-loading') === '1') {
            return;
        }

        const productLayoutProductId = popup.find('input[name="product_layout_product_id"]').val();
        const previouslySelectedId = select.val();
        select.attr('data-configs-loading', '1').prop('disabled', true);
        displayTicketProductConfigMessage('Henter billettproduktkonfigurasjoner...');

        $.ajax({
            type: 'GET',
            url: pathAjax + '/' + getProductLayoutId() + '/' + pathProductLayoutProduct + '/'
                + productLayoutProductId + '/ticket-product-configs',
            dataType: 'json'
        }).done(function (data) {
            const configs = data && Array.isArray(data.configs) ? data.configs : [];
            const selectedIdFromServer = parseInt(data.selected_ticket_product_config_id, 10) || 0;
            const selectedId = selectedIdFromServer > 0
                ? String(selectedIdFromServer)
                : String(previouslySelectedId || '');

            select.empty().append(
                $('<option></option>').attr('value', '').text('Velg billettproduktkonfigurasjon')
            );

            configs.forEach(function (config) {
                select.append(
                    $('<option></option>')
                        .attr('value', config.id)
                        .text(config.name)
                );
            });

            if (selectedId && select.find('option[value="' + selectedId + '"]').length) {
                select.val(selectedId);
                select.trigger('change');
            }

            select.attr('data-configs-loaded', '1');
            displayTicketProductConfigMessage(data.message || '');
        }).fail(function (response) {
            let errorMessage = 'Kunne ikke hente billettproduktkonfigurasjoner.';
            if (response.responseJSON && response.responseJSON.errors) {
                errorMessage = Array.isArray(response.responseJSON.errors)
                    ? response.responseJSON.errors.join('\n')
                    : response.responseJSON.errors;
            }
            displayTicketProductConfigMessage(errorMessage);
        }).always(function () {
            select.removeAttr('data-configs-loading').prop('disabled', false);
        });
    }

    /**
     *
     * @param targetType 0 = product, 1 = product_layout, 2 = product_group,
     * 4 = extra_product, 6 = customer, 7 = ticket
     */
    function refreshModalAfterTargetTypeSelection(targetType) {
        targetType = targetType * 1;
        if (isNaN(targetType)) {
            alert("Ugyldig target type: " + targetType);
            return;
        }

        // Hide all, then display the correct elements
        $('div#' + productButtonModalId + ' .display_for_products, ' +
            'div#' + productButtonModalId + ' .display_for_product_layout, ' +
            'div#' + productButtonModalId + ' .display_for_product_group, ' +
            'div#' + productButtonModalId + ' .display_for_extra_products, ' +
            'div#' + productButtonModalId + ' .display_for_customers, ' +
            'div#' + productButtonModalId + ' .display_for_tickets').each(function () {
            if (!$(this).hasClass('hidden')) {
                $(this).addClass('hidden');
            }
        });

        if (targetType === 0) {
            $('div#' + productButtonModalId + ' .display_for_products').each(function () {
                $(this).removeClass('hidden');
            });
        } else if (targetType === 1) {
            $('div#' + productButtonModalId + ' .display_for_product_layout').each(function () {
                $(this).removeClass('hidden');
            });
        } else if (targetType === 2) {
            $('div#' + productButtonModalId + ' .display_for_product_group').each(function () {
                $(this).removeClass('hidden');
            });
        } else if (targetType === 4) {
            $('div#' + productButtonModalId + ' .display_for_extra_products').each(function () {
                $(this).removeClass('hidden');
            });
        } else if (targetType === 6) {
            $('div#' + productButtonModalId + ' .display_for_customers').each(function () {
                $(this).removeClass('hidden');
            });
        } else if (targetType === 7) {
            $('div#' + productButtonModalId + ' .display_for_tickets').each(function () {
                $(this).removeClass('hidden');
            });
            loadTicketProductConfigs();
        }
    }

    function hideProductLayoutProductsMultipleEditModal() {
        hideModal('product_layout_products_multiple_edit_popup');
    }

    function showProductLayoutProductsMultipleEditModal() {
        showModal('product_layout_products_multiple_edit_popup');
    }

    function closeMultipleEditMode() {
        hideProductLayoutProductsMultipleEditModal();
        $('#product_layout_products_multiple_edit').prop('checked', false);
        $('div#product_layout_wrapper ul#product_layout_sortable_ul li').removeClass('multiple-edit');
        $('#product_layout_products_multiple_edit_buttons').addClass('hidden');
        uncheckedConfirmationFieldsMultipleEditMode();
    }

    function uncheckedConfirmationFieldsMultipleEditMode() {
        $('#product_layout_products_multiple_edit_confirm_background_color').prop('checked', false);
        $('#product_layout_products_multiple_edit_confirm_font_color').prop('checked', false);
        $('#product_layout_products_multiple_edit_confirm_font_size').prop('checked', false);
    }

    $(document).on('change', '#product_layout_products_multiple_edit', function () {
        if ($(this).is(':checked')) {
            $('#product_layout_products_multiple_edit_buttons').removeClass('hidden');
        } else {
            closeMultipleEditMode();
        }

        return false;
    });

    $(document).on('click', '#product_layout_products_multiple_edit_btn_cancel', function () {
        closeMultipleEditMode();
        return false;
    });

    $(document).on('click', '#product_layout_products_multiple_edit_btn_popup', function () {
        if (!$('div#product_layout_wrapper ul#product_layout_sortable_ul li.multiple-edit').length) {
            alert('Du valgte ikke noen produktlayoutprodukter for flere redigeringer');
            return;
        }
        $('.color-picker').remove();
        closePopup();
        showProductLayoutProductsMultipleEditModal();
        initColorPickers('product_layout_products_multiple_edit_popup');

        return false;
    });

    $(document).on('click', '#product_layout_products_multiple_edit_btn_save', function () {
        if (ajaxLockActive === true) {
            return;
        }

        const backgroundColorConfirmVal = $('#product_layout_products_multiple_edit_confirm_background_color').is(':checked');
        const fontColorConfirmVal = $('#product_layout_products_multiple_edit_confirm_font_color').is(':checked');
        const fontSizeConfirmVal = $('#product_layout_products_multiple_edit_confirm_font_size').is(':checked');

        if (!backgroundColorConfirmVal && !fontColorConfirmVal && !fontSizeConfirmVal) {
            alert('Du må velge minst én parameter du vil endre for hovedgruppeknapper');
            return;
        }

        ajaxLockActive = true;

        const buttonIds = [];

        $('#product_layout_sortable_ul li.multiple-edit').each(function (_, button) {
            buttonIds.push($(button).attr('product_layout_product_id'))
        });

        const bgColor = $('div#product_layout_products_multiple_edit_popup button#product_layout_products_multiple_edit_background_color_picker').css("backgroundColor");
        const fontColor = $('div#product_layout_products_multiple_edit_popup button#product_layout_products_multiple_edit_font_color_picker').css("backgroundColor");
        const fontSize = $('div#product_layout_products_multiple_edit_popup select#product_layout_products_multiple_edit_font_size_picker').val();

        const formData = {
            ids: buttonIds
        }

        if (backgroundColorConfirmVal) {
            formData.background_color = bgColor;
        }
        if (fontColorConfirmVal) {
            formData.font_color = fontColor;
        }
        if (fontSizeConfirmVal) {
            formData.font_size = fontSize;
        }

        $.ajax({
            type: 'POST',
            url: pathAjax + '/' + getProductLayoutId() + '/' + pathMultipleEditProductLayoutProducts,
            data: JSON.stringify(formData),
            contentType: 'application/json'
        }).success(function () {
            ajaxLockActive = false;
            closeMultipleEditMode();
            getProductButtons(getPageNumber());
        }).error(function (data) {
            const errors = $.parseJSON(data.responseText).errors;
            alert(errors);
        }).always(function () {
            uncheckedConfirmationFieldsMultipleEditMode();
            ajaxLockActive = false;
        });
        return false;
    });
    $(document).on('click', '#openProductLayoutTranslations', function (e) {
        e.preventDefault();
        const $div = $('div#product_layout_wrapper');
        const $name = $div.find('input#product_layout_name_edit_v2');
        $('#productLayoutTranslations #name_nb').val($name.val());
        // Prefill from hidden fields (server-side populated); if empty, try fetching from API
        let enVal = $('#name_translation_en_GB').val() || '';
        let deVal = $('#name_translation_de_DE').val() || '';
        if (!enVal || !deVal) {
            const pid = parseInt($('#product_layout_id').val(), 10) || 0;
            if (pid > 0) {
                $.ajax({
                    type: 'GET',
                    url: '/action/translations/product-layout-translations',
                    data: { search: '', language: 'en' },
                    dataType: 'json'
                }).always(function () {
                    $('#productLayoutTranslations #name_en').val(enVal);
                    $('#productLayoutTranslations #name_de').val(deVal);
                    showModal('productLayoutTranslations');
                });
            } else {
                $('#productLayoutTranslations #name_en').val(enVal);
                $('#productLayoutTranslations #name_de').val(deVal);
                showModal('productLayoutTranslations');
            }
        } else {
            $('#productLayoutTranslations #name_en').val(enVal);
            $('#productLayoutTranslations #name_de').val(deVal);
            showModal('productLayoutTranslations');
        }
        return false;
    });

    $(document).on('click', '.js-copy-from-default', function () {
        const $btn = $(this);
        const targetSelector = ($btn.data('target') || '').toString();
        if (!targetSelector) { return; }
        const $modal = $btn.closest('.modal');
        let defaultVal = '';
        if ($modal.attr('id') === 'productLayoutTranslations') {
            defaultVal = $modal.find('#name_nb').val();
        }
        $(targetSelector).val(defaultVal);
    });

    // Inline save on blur for translation inputs; show notify; skip empty
    $(document).on('focusout', '#productLayoutTranslations input.js-locale', function () {
        const $input = $(this);
        const rawLang = $input.data('locale') || '';
        const lang = (rawLang + '').split('-')[0].toLowerCase();
        const value = ($input.val() || '').trim();
        if (value === '') { return; }
        const productLayoutId = parseInt($('#product_layout_id').val(), 10) || 0;
        if (productLayoutId <= 0) {
            // store in hidden fields
            if (lang === 'en') { $('#name_translation_en_GB').val(value); }
            else if (lang === 'de') { $('#name_translation_de_DE').val(value); }
            try { $input.notify('Lagret!', { position: 'left', className: 'success' }); } catch (e) {}
            return;
        }
        $.ajax({
            type: 'POST',
            url: '/action/translations/update-product-layout-translations',
            data: {
                productLayoutId: productLayoutId,
                field: 'name',
                lang: lang,
                value: value
            },
            dataType: 'json'
        }).done(function (res) {
            try { $input.notify('Lagret!', { position: 'left', className: 'success' }); } catch (e) {
                // fallback: no-op
            }
            if (lang === 'en') { $('#name_translation_en_GB').val(value); }
            else if (lang === 'de') { $('#name_translation_de_DE').val(value); }
        });
    });

    // Inline save on blur for TEXT2 (button label) translations inside product_layout_popup
    $(document).on('focusout', 'div#' + productButtonModalId + ' input#product_layout_product_button_text_en, div#' + productButtonModalId + ' input#product_layout_product_button_text_de', function () {
        const $input = $(this);
        const id = ($input.attr('id') || '').toString();
        const lang = id.endsWith('_de') ? 'de' : 'en';
        const value = ($input.val() || '').trim();
        if (value === '') { return; }
        const productLayoutProductId = parseInt($('div#' + productButtonModalId + ' input[name="product_layout_product_id"]').val(), 10) || 0;
        if (productLayoutProductId <= 0) {
            // Defer saving until the button is created and ID is known
            return;
        }
        $.ajax({
            type: 'POST',
            url: '/action/translations/update-product-layout-product-translations',
            data: {
                productLayoutProductId: productLayoutProductId,
                field: 'name',
                lang: lang,
                value: value
            },
            dataType: 'json'
        }).done(function () {
            try { $input.notify('Lagret!', { position: 'left', className: 'success' }); } catch (e) {}
        });
    });

    $(document).on('shown.tw.modal', '#productLayoutTranslations', function () {
        const $modal = $(this);
        $modal.css('z-index', 1060);
        $('#productLayoutTranslations #name_nb').focus().select();
    });

    // Helper function to soft delete product layout translations
    function deleteProductLayoutTranslations(productLayoutId) {
        $.ajax({
            type: 'POST',
            url: '/action/translations/delete-translations',
            data: JSON.stringify({
                entityId: productLayoutId,
                entityType: 3 // 3 = product_layouts
            }),
            contentType: 'application/json',
            dataType: 'json'
        }).done(function(response) {
            if (response && response.ok) {
                console.log('Product layout translations soft deleted');
            }
        }).fail(function(error) {
            console.warn('Failed to delete product layout translations:', error);
        });
    }

    // Helper function to restore product layout translations
    function restoreProductLayoutTranslations(productLayoutId) {
        $.ajax({
            type: 'POST',
            url: '/action/translations/restore-translations',
            data: JSON.stringify({
                entityId: productLayoutId,
                entityType: 3 // 3 = product_layouts
            }),
            contentType: 'application/json',
            dataType: 'json'
        }).done(function(response) {
            if (response && response.ok) {
                console.log('Product layout translations restored');
            }
        }).fail(function(error) {
            console.warn('Failed to restore product layout translations:', error);
        });
    }

    // Helper function to soft delete product layout product translations
    function deleteProductLayoutProductTranslations(productLayoutProductId) {
        $.ajax({
            type: 'POST',
            url: '/action/translations/delete-translations',
            data: JSON.stringify({
                entityId: productLayoutProductId,
                entityType: 4 // 4 = product_layout_products
            }),
            contentType: 'application/json',
            dataType: 'json'
        }).done(function(response) {
            if (response && response.ok) {
                console.log('Product layout product translations soft deleted');
            }
        }).fail(function(error) {
            console.warn('Failed to delete product layout product translations:', error);
        });
    }

    function loadProductPickerProducts() {
        const targetType = $('#product_layout_picker_target_type').val();
        const productGroupId = $('#product_layout_picker_product_group_filter').val();
        const searchString = $('#product_layout_picker_search').val();

        $('#product_layout_picker_search').prop('disabled', false);
        $('#product_layout_picker_products').html('<div class="p-4 text-sm text-slate-500">Henter produkter...</div>');

        $.ajax({
            type: 'GET',
            url: pathAjax + '/' + getProductLayoutId() + '/product-picker-products',
            data: {
                target_type: targetType,
                product_group_id: productGroupId,
                search_string: searchString
            },
            dataType: 'json'
        }).success(function (data) {
            $('#product_layout_picker_products').html(data.html);
        }).error(function () {
            $('#product_layout_picker_products').html('<div class="p-4 text-sm text-danger">Kunne ikke hente produkter.</div>');
        });
    }

    function refreshProductPickerFilters() {
        const targetType = $('#product_layout_picker_target_type').val() * 1;
        const productGroupFilterWrapper = $('#product_layout_picker_product_group_filter_wrapper');

        if (targetType === 0) {
            productGroupFilterWrapper.removeClass('hidden');
        } else {
            $('#product_layout_picker_product_group_filter').val('');
            productGroupFilterWrapper.addClass('hidden');
        }
    }

    $(document).on('change', '#product_layout_picker_target_type', function () {
        refreshProductPickerFilters();
        loadProductPickerProducts();
    });

    $(document).on('change', '#product_layout_picker_product_group_filter', loadProductPickerProducts);

    $(document).on('input', '#product_layout_picker_search', function () {
        clearTimeout(productPickerSearchTimer);
        productPickerSearchTimer = setTimeout(loadProductPickerProducts, 250);
    });

    if ($('#product_layout_product_picker').length) {
        refreshProductPickerFilters();
        loadProductPickerProducts();
    }

    $(document).on('dragstart', '.product-layout-picker-item', function (event) {
        const payload = {
            target_type: $(this).data('target-type') * 1,
            target_id: $(this).data('target-id') * 1,
            target_name: $(this).data('target-name')
        };

        event.originalEvent.dataTransfer.setData('application/json', JSON.stringify(payload));
        event.originalEvent.dataTransfer.effectAllowed = 'copy';
    });

    $(document).on('dragover', '#product_layout_sortable_ul li', function (event) {
        event.preventDefault();
        $(this).addClass('ring-2 ring-primary ring-offset-1');
    });

    $(document).on('dragleave drop', '#product_layout_sortable_ul li', function () {
        $(this).removeClass('ring-2 ring-primary ring-offset-1');
    });

    $(document).on('drop', '#product_layout_sortable_ul li', function (event) {
        event.preventDefault();

        const rawPayload = event.originalEvent.dataTransfer.getData('application/json');
        if (!rawPayload) {
            return;
        }

        const payload = JSON.parse(rawPayload);
        const targetButton = $(this);
        const productLayoutProductId = targetButton.attr('product_layout_product_id');
        const requestData = {
            target_type: payload.target_type,
            product_id: 0,
            product_group_id: 0,
            product_layout_id: 0,
            font_size: targetButton.find('input[name^="product_layout_product_font_size"]').val() || 14,
            bg_color: targetButton.find('input[name^="product_layout_product_bg_color"]').val() || '',
            font_color: targetButton.find('input[name^="product_layout_product_font_color"]').val() || '',
            button_text: ''
        };

        if (payload.target_type === 0) {
            requestData.product_id = payload.target_id;
        } else if (payload.target_type === 1) {
            requestData.product_layout_id = payload.target_id;
        } else if (payload.target_type === 2) {
            requestData.product_group_id = payload.target_id;
        }

        $.ajax({
            type: 'POST',
            url: pathAjax + '/' + getProductLayoutId() + '/' + pathProductLayoutProduct + '/' + productLayoutProductId,
            data: requestData,
            dataType: 'json'
        }).success(function () {
            getProductButtons(getPageNumber());
        }).error(function () {
            alert('Kunne ikke legge til produkt');
        });
    });
});
